export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5941.0dc05365.jpg";